export default "__VITE_ASSET__DXIC2qcV__";